module.exports = __webpack_public_path__ + "static/media/full-screen.297b6d2e.svg";